import {Component, Input} from "@angular/core";
import {ALL_COMPARATORS, VALUE_TYPE} from "../../../enums/enums";
import {ObjListService} from "../../../services/objListService";


@Component({
  selector: "nv-stage-obj-list",
  templateUrl: "./nv-stage-obj-list.component.html"
})


export class NvStageObjListComponent {
  VAL_TYPES = VALUE_TYPE;
  ALL_COMPARATORS = ALL_COMPARATORS;


  @Input() document: Object;
  @Input() prop: string;


  constructor(private objListService: ObjListService) {
  }


  add() {
    this.objListService.addTo(this.document, this.prop);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-stages/conditions/nv-stage-obj-list.component.ts